import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Donations from './donations';

export default (
  <Route path="donations">
    <IndexRoute component={props => <Donations {...props} />} />
  </Route>
);
